import type { VmAdminStatistics } from "@warrenio/api-spec/spec.oats.gen";

export const adminVmStatisticsExample: VmAdminStatistics = {
    by_cpu: {
        "1": {
            running: 102,
            stopped: 161,
        },
        "2": {
            running: 252,
            stopped: 271,
        },
        "4": {
            running: 12,
            stopped: 33,
        },
        "16": {
            running: 25,
            stopped: 11,
        },
    },
    by_mem: {
        "1.0": {
            running: 31,
            stopped: 26,
        },
        "3.0": {
            running: 0,
            stopped: 2,
        },
        "4.0": {
            running: 1,
            stopped: 3,
        },
        "2.0": {
            running: 3,
            stopped: 6,
        },
        "12.0": {
            running: 0,
            stopped: 6,
        },
    },
    by_os: {
        debian: {
            running: 4,
            stopped: 2,
        },
        service: {
            running: 16,
            stopped: 20,
        },
        pfsense: {
            running: 0,
            stopped: 1,
        },
        windows: {
            running: 13,
            stopped: 3,
        },
        fedora: {
            running: 13,
            stopped: 11,
        },
        windows_unlicensed: {
            running: 61,
            stopped: 12,
        },
        ubuntu: {
            running: 13,
            stopped: 12,
        },
        _custom: {
            running: 12,
            stopped: 33,
        },
    },
};

export const adminVmStatisticsExample2: VmAdminStatistics = {
    by_cpu: {
        "1": {
            running: 1,
            stopped: 5,
        },
        "2": {
            running: 12,
            stopped: 3,
        },
    },
    by_mem: {
        "1.0": {
            running: 14,
            stopped: 7,
        },
        "4.0": {
            running: 12,
            stopped: 1,
        },
    },
    by_os: {
        linux: {
            running: 11,
            stopped: 1,
        },
        service: {
            running: 34,
            stopped: 1,
        },
        ubuntu: {
            running: 14,
            stopped: 44,
        },
        windows: {
            running: 12,
            stopped: 15,
        },
        debian: {
            running: 1,
            stopped: 12,
        },
    },
};

// cspell:words pfsense
